import { useState } from 'react';
import { Input } from '@/components/ui/input.jsx';
import { toast } from '@/components/ui/toaster.jsx';
import { senderFor } from './doors.js';
import { PHF_CORRECT_WORDS } from './words.js';

// DAVID'S CORRECTION TO A PILOT'S PHF, ALWAYS OPEN (V3 Overnight 3, lane C).
// Every PHF-correctable pilot row on the people card carries this, whatever
// the form's status (invited, in progress, submitted, verified) and whether or
// not AIRgus names the row: the lock was that the v3 page offered a field only
// where an AIRgus item asked for one. It posts through doors.js senderFor, the
// record's phf_field door (factWriters inlineSender, PATCH /api/tracon/phf/:id/field,
// services/phf-correction.service.js correctPhfField): the one writer. The
// server records the signed-in broker as the actor and leaves raw_submission,
// the pilot's own attested answers, untouched. A reason is required here
// because the door requires one; nothing is defaulted on David's behalf.
// `target` names the form the correction writes (the one the card shows), in
// words the card already printed; it is said inside the open control.
export default function PhfCorrection({ fact_ref, ctx, label, target, onSaved }) {
  const { sender } = senderFor(fact_ref, ctx);
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState('');
  const [reason, setReason] = useState('');
  const [saving, setSaving] = useState(false);
  if (!sender) return <span className="text-xs text-text-dim" data-phf-correct="no-form">{PHF_CORRECT_WORDS.no_form}</span>;
  if (!open) {
    return (
      <button type="button" onClick={() => { setValue(''); setReason(''); setOpen(true); }} className="ml-3 inline-flex min-h-[36px] items-center text-xs text-text-dim underline-offset-2 hover:text-text hover:underline" data-phf-correct="closed">
        {PHF_CORRECT_WORDS.open}
      </button>
    );
  }
  const save = async (e) => {
    e.preventDefault();
    if (saving) return;
    if (!value.trim() || !reason.trim()) { toast.error(PHF_CORRECT_WORDS.both_required); return; }
    setSaving(true);
    try {
      const r = await sender(value.trim(), reason.trim());
      if (r && r.success === false) throw new Error(r.error || 'Save failed');
      toast.success(r?.unchanged ? PHF_CORRECT_WORDS.unchanged : `${label}: ${PHF_CORRECT_WORDS.saved}`);
      if (r?.mirror && r.mirror.applied === false) toast.error(`${PHF_CORRECT_WORDS.mirror_failed} ${r.mirror.error || r.mirror.code}`);
      setOpen(false);
      onSaved?.();
    } catch (err) { toast.error(err?.body?.error || err?.message || 'Could not save the edit'); }
    finally { setSaving(false); }
  };
  return (
    <form onSubmit={save} className="mt-1 flex flex-wrap items-center gap-2" data-phf-correct="open">
      <span className="w-full text-xs text-text-dim" data-phf-correct-target>{PHF_CORRECT_WORDS.writes} {target || PHF_CORRECT_WORDS.target_unknown}</span>
      <Input value={value} onChange={(e) => setValue(e.target.value)} placeholder={label} aria-label={`${label}, new value`} className="min-h-[36px] w-40 font-mono text-sm" disabled={saving} autoFocus />
      <Input value={reason} onChange={(e) => setReason(e.target.value)} placeholder={PHF_CORRECT_WORDS.reason_placeholder} aria-label="Reason for the edit" className="min-h-[36px] min-w-[200px] flex-1 text-sm" disabled={saving} />
      <button type="submit" disabled={saving} className="min-h-[36px] rounded-card border border-accent bg-accent px-3 text-sm font-medium text-white disabled:opacity-60">{saving ? 'Saving' : 'Save edit'}</button>
      <button type="button" disabled={saving} onClick={() => setOpen(false)} className="min-h-[36px] px-2 text-sm text-text-dim hover:text-text">Cancel</button>
    </form>
  );
}
